// extracted by mini-css-extract-plugin
module.exports = {"selectedRange":"PriceRangeFilter-module--selectedRange--7d9d97","reset":"PriceRangeFilter-module--reset--d944a9","minMaxValues":"PriceRangeFilter-module--minMaxValues--986953"};